import { cn } from 'utils/styles';

type ButtonsWrapperProps = React.ComponentProps<'div'>;

export const ButtonsWrapper = ({ children, className, ...props }: ButtonsWrapperProps) => {
  return (
    <div className={cn('flex gap-3', className)} {...props}>
      {children}
    </div>
  );
};
